var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-bubble',{attrs:{"isMine":_vm.isMine,"message":_vm.message}},[_vm._l((_vm.contentList),function(item,index){return [(item.name === 'text')?_c('span',{key:index},[_vm._v(_vm._s(item.text))]):(item.name === 'img')?_c('img',{key:index,attrs:{"src":item.src,"width":"20px","height":"20px"}}):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30b0e75f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/im/message/message-elements/text-element.vue
// module id = null
// module chunks = 